"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketMessageEnvelope = exports.SocketErrorMessage = exports.SocketPongMessage = exports.SocketPingMessage = exports.SourSocketType = void 0;
const typebox_1 = require("@sinclair/typebox");
const SourSocketMessageTypes = ['MESSAGE', 'ERROR', 'PING', 'PONG'];
exports.SourSocketType = typebox_1.Type.Union(SourSocketMessageTypes.map((t) => typebox_1.Type.Literal(t)));
exports.SocketPingMessage = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('PING'),
    timestamp: typebox_1.Type.String({
        format: 'date-time',
    }),
});
exports.SocketPongMessage = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('PONG'),
    timestamp: typebox_1.Type.String({
        format: 'date-time',
    }),
});
exports.SocketErrorMessage = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('ERROR'),
    timestamp: typebox_1.Type.String({
        format: 'date-time',
    }),
    error: typebox_1.Type.String(),
    additionalInfo: typebox_1.Type.Optional(typebox_1.Type.String()),
});
const SocketMessageEnvelope = (payloadSchema) => typebox_1.Type.Object({
    type: typebox_1.Type.Literal('MESSAGE'),
    timestamp: typebox_1.Type.String({
        format: 'date-time',
    }),
    payload: payloadSchema,
});
exports.SocketMessageEnvelope = SocketMessageEnvelope;
//# sourceMappingURL=socket-message.js.map